import { createSlice } from "@reduxjs/toolkit";

const layoutSlice = createSlice({
    name: "layout",
    initialState: {
        sidebarShow: true,
        theme: 'light',
        loading: false
    },
    reducers: {
        changeState(state, action) {
            let { type, ...rest } = action.payload
            switch (type) {
                case 'set':
                    return { ...state, ...rest }
                default:
                    return state
            }
        },
        setLoading(state, action) {
            state.loading = action.payload
        }
    }
});

export const { changeState, setLoading } = layoutSlice.actions;
export default layoutSlice.reducer;